import { render, staticRenderFns } from "./OrderLogistics.vue?vue&type=template&id=31a5c8aa"
import script from "./OrderLogistics.vue?vue&type=script&lang=js"
export * from "./OrderLogistics.vue?vue&type=script&lang=js"
import style0 from "./OrderLogistics.vue?vue&type=style&index=0&id=31a5c8aa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports